import React from "react";

interface IProps {
    fundsProtection: number;
    fundsProtectionTypes: IValueLabel[];
    fundsProtectionDescription?: string;
}

interface IValueLabel {
    value: number;
    label: string;
}

const FUNDS_PROTECTION_DESCRIPTION = 6;

export const OfferDetailFundsProtection = React.memo((props: IProps) => {
    const foundFundProtectionTypes = props.fundsProtectionTypes?.find((fPT) => fPT.value === props.fundsProtection);

    return foundFundProtectionTypes && foundFundProtectionTypes.value === FUNDS_PROTECTION_DESCRIPTION && props.fundsProtectionDescription ? (
        <>{`${props.fundsProtectionDescription.toLocaleLowerCase()}`}</>
    ) : (
        <>{`${foundFundProtectionTypes && foundFundProtectionTypes.label.toLocaleLowerCase()}`}</>
    );
});
import React from "react";

interface IProps {
    fundsProtection: number;
    fundsProtectionTypes: IValueLabel[];
    fundsProtectionDescription?: string;
}

interface IValueLabel {
    value: number;
    label: string;
}

const FUNDS_PROTECTION_DESCRIPTION = 6;

export const OfferDetailFundsProtection = React.memo((props: IProps) => {
    const foundFundProtectionTypes = props.fundsProtectionTypes?.find((fPT) => fPT.value === props.fundsProtection);

    return foundFundProtectionTypes && foundFundProtectionTypes.value === FUNDS_PROTECTION_DESCRIPTION && props.fundsProtectionDescription ? (
        <>{`${props.fundsProtectionDescription.toLocaleLowerCase()}`}</>
    ) : (
        <>{`${foundFundProtectionTypes && foundFundProtectionTypes.label.toLocaleLowerCase()}`}</>
    );
});
